import dayjs from "dayjs";
import { pnlFmt, pnlColor, priceFmt } from "@/lib/format";

export default function TradesTable({ trades, variant = "admin", onClose, onEdit, onDelete, testid }) {
  const isClient = variant === "client";
  const headers = [
    "Ticket", "Open Time", "Symbol", "Type", "Volume",
    ...(isClient ? [] : ["Clients"]),
    "Open Price", "Close Price", "S/L", "T/P", "Profit",
    ...(isClient ? [] : ["Actions"]),
  ];

  return (
    <div className="overflow-x-auto rounded-lg border border-[#2A2E39] bg-[#131722]">
      <table data-testid={testid} className="w-full min-w-[960px] text-sm">
        <thead>
          <tr className="border-b border-[#2A2E39]">
            {headers.map((h) => (
              <th
                key={h}
                className="whitespace-nowrap px-3 py-2.5 text-left text-[11px] font-medium uppercase tracking-wider text-[#848E9C]"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {trades.length === 0 && (
            <tr>
              <td colSpan={headers.length} className="px-3 py-10 text-center text-sm text-[#5E6673]">
                No trades found
              </td>
            </tr>
          )}
          {trades.map((t) => (
            <tr
              key={t.id}
              data-testid={`trade-row-${t.ticket}`}
              className="border-b border-[#1E222D] transition-colors hover:bg-[#1E222D]/60"
            >
              <td className="whitespace-nowrap px-3 py-2 font-mono text-[#EAECEF]">#{t.ticket}</td>
              <td className="whitespace-nowrap px-3 py-2 font-mono text-xs text-[#848E9C]">
                {dayjs(t.open_time).format("YYYY.MM.DD HH:mm")}
              </td>
              <td className="whitespace-nowrap px-3 py-2 font-mono font-semibold text-[#EAECEF]">{t.symbol}</td>
              <td className="whitespace-nowrap px-3 py-2">
                <span
                  className={`rounded px-1.5 py-0.5 font-mono text-[11px] font-bold ${
                    t.type === "buy"
                      ? "bg-[rgba(14,203,129,0.12)] text-[#0ECB81]"
                      : "bg-[rgba(246,70,93,0.12)] text-[#F6465D]"
                  }`}
                >
                  {t.type.toUpperCase()}
                </span>
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#EAECEF]">
                {Number(t.volume).toFixed(4)}
              </td>
              {!isClient && (
                <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#848E9C]">
                  {t.client_count}
                </td>
              )}
              <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#EAECEF]">{priceFmt(t.open_price)}</td>
              <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#EAECEF]">{priceFmt(t.close_price)}</td>
              <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#5E6673]">{priceFmt(t.sl)}</td>
              <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-[#5E6673]">{priceFmt(t.tp)}</td>
              <td className={`whitespace-nowrap px-3 py-2 text-right font-mono font-semibold ${t.status === "closed" ? pnlColor(t.profit) : "text-[#5E6673]"}`}>
                {t.status === "closed" ? pnlFmt(t.profit) : "OPEN"}
              </td>
              {!isClient && (
                <td className="whitespace-nowrap px-3 py-2 text-right">
                  <div className="flex justify-end gap-1">
                    {t.status === "open" && (
                      <button
                        data-testid={`close-trade-btn-${t.ticket}`}
                        onClick={() => onClose(t)}
                        className="rounded border border-[#F0B90B]/40 bg-[#F0B90B]/10 px-2 py-1 text-[11px] font-semibold text-[#F0B90B] transition-colors hover:bg-[#F0B90B]/20"
                      >
                        Close
                      </button>
                    )}
                    <button
                      data-testid={`edit-trade-btn-${t.ticket}`}
                      onClick={() => onEdit(t)}
                      className="rounded border border-[#2A2E39] bg-[#1E222D] px-2 py-1 text-[11px] font-semibold text-[#EAECEF] transition-colors hover:bg-[#2A2E39] hover:text-[#F0B90B]"
                    >
                      Edit
                    </button>
                    <button
                      data-testid={`delete-trade-btn-${t.ticket}`}
                      onClick={() => onDelete(t)}
                      className="rounded border border-[#F6465D]/40 bg-[#F6465D]/10 px-2 py-1 text-[11px] font-semibold text-[#F6465D] transition-colors hover:bg-[#F6465D]/20"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
